const hookBlockFactory = (prefix) => (block) => {
    const blockClass = `${prefix}__${block}`;
    const getBlock = () => {
        return blockClass;
    };
    getBlock.childBlock = hookBlockFactory(blockClass);
    getBlock.element = (element) => {
        return `${blockClass}__${element}`;
    };
    getBlock.makeModifierFactory =
        () => (modifier) => {
            return `${blockClass}--${modifier}`;
        };
    getBlock.modifier = getBlock.makeModifierFactory();
    return getBlock;
};
export const makeHookBlock = (block) => {
    return hookBlockFactory("e2e")(block);
};
const asClassSelector = (identifier) => {
    return `.${identifier}`;
};
export const makeClassSelectors = (hooks) => {
    return Object.entries(hooks).reduce((acc, [name, hook]) => {
        switch (typeof hook) {
            case "function": {
                acc[name] = (identifier) => asClassSelector(hook(identifier));
                break;
            }
            case "object": {
                acc[name] = makeClassSelectors(hook);
                break;
            }
            case "string": {
                acc[name] = asClassSelector(hook);
                break;
            }
            case "bigint":
            case "boolean":
            case "number":
            case "symbol":
            case "undefined":
                throw new Error(`Unable to make type ${typeof hook} into a class selector.`);
        }
        return acc;
    }, {});
};
//# sourceMappingURL=make-hooks.js.map